import { CallingTree } from '../models/calling-tree.model';
import { CallingTreeAdmins } from '../models/calling-tree-admins.model';

export class GetNumberOfBranches {
	static readonly type = '[Calling Tree] GetNumberOfBranches';
}

export class SelectCallingTreeBranch {
	static readonly type = '[Calling Tree] SelectCallingTreeBranch';
	constructor(public branch: number) {}
}

export class UpdateCoordinators {
	static readonly type = '[Calling Tree] UpdateCoordinators';
	constructor(public callingTree: CallingTree) {}
}

export class GetCallingTreeAdmins {
	static readonly type = '[Calling Tree] GetCallingTreeAdmins';
}

export class UpdateCallingTreeAdmins {
	static readonly type = '[Calling Tree] UpdateCallingTreeAdmins';
	constructor(public admins: CallingTreeAdmins) {}
}

export class GetCallingTreeView {
	static readonly type = '[Calling Tree] GetCallingTreeView';
}

export class GetAvailableBranchMembers {
	static readonly type = '[Calling Tree] GetAvailableBranchMembers';
	constructor(public branch: number) {}
}

export class AddUserToBranch {
	static readonly type = '[Calling Tree] AddUserToBranch';
	constructor(
		public userId: number,
		public branch: number
	) {}
}

export class RemoveUserFromBranch {
	static readonly type = '[Calling Tree] RemoveUserFromBranch';
	constructor(
		public userId: number,
		public newBranch: number
	) {}
}
